import type React from "react"
import { CheckCircle } from "lucide-react"

const KeyFeatures: React.FC = () => {
  const features = [
    {
      title: "Appointment Booking",
      description:
        "Book, reschedule, or cancel appointments with healthcare providers seamlessly through the platform.",
    },
    {
      title: "Unified Medical Records",
      description: "Access and manage all your medical records in one secure place, accessible anytime, anywhere.",
    },
  
    // {
    //   title: "ABHA Integration",
    //   description: "Link your ABHA ID for a unified digital health record across all healthcare providers.",
    // },
    {
      title: "Family Health Management",
      description: "Manage health records and appointments for your family members in one convenient platform.",
    },
    {
      title: "Secure Data Protection",
      description: "Your data is protected with bank-level encryption and strict privacy controls.",
    },
    {
      title: "Mobile Accessibility",
      description: "Access PatientCare on your mobile.",
    },
  ]

  return (
    <section id="features" className="py-20 bg-gradient-to-br from-blue-50 to-white">
      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-16">
          <span className="inline-block px-5 py-2 bg-gradient-to-r from-[#e6fffa] to-[#b2f5ea] text-[#008080] rounded-full text-sm font-medium font-roboto mb-6 shadow-lg border border-[#99f6e4] hover:shadow-xl hover:-translate-y-0.5 transform transition-all duration-300">
              Our Features
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-[#008080] mb-4 font-nunito">
              Key Features of PatientCare
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-[#008080] to-[#00a3a3] mx-auto rounded-full mb-6"></div>
            <p className="text-gray-600 max-w-3xl mx-auto font-roboto">
              Discover how PatientCare empowers you to manage your healthcare with ease, security, and efficiency.
            </p>
          </div>

          {/* Features Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {features.map((feature, index) => (
              <div
                key={index}
                className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 transition-all duration-300 hover:shadow-md hover:translate-y-[-4px] group"
              >
                <div className="flex items-center mb-4">
                  <div className="w-10 h-10 rounded-full bg-[#e6fffa] flex items-center justify-center mr-4 group-hover:bg-[#008080] transition-colors duration-300">
                    <CheckCircle className="w-5 h-5 text-[#008080] group-hover:text-white transition-colors duration-300" />
                  </div>
                  <h3 className="text-lg font-semibold text-gray-800 font-nunito">{feature.title}</h3>
                </div>
                <p className="text-gray-600 text-sm font-roboto leading-relaxed pl-14">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default KeyFeatures
